import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
  Box,
} from "@mui/material";
import { Warning, CheckCircle, Delete, Info } from "@mui/icons-material";
import * as SC from "./confirmation-dialog.style";
import { ConfirmationDialogProps } from "./confirmation-dialog.type";

const getIconForAction = (confirmColor?: string) => {
  switch (confirmColor) {
    case "error":
      return <Warning color="error" />;
    case "success":
      return <CheckCircle color="success" />;
    case "warning":
      return <Info color="info" />;
    case "info":
      return <Info color="info" />;
    default:
      return <Warning color="primary" />;
  }
};

export const ConfirmationDialogComponent = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "تایید",
  cancelText = "لغو",
  confirmColor = "primary",
  isLoading = false,
}: ConfirmationDialogProps) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown={isLoading}
    >
      <DialogTitle>{title}</DialogTitle>
      <SC.ConfirmationDialog>
        <DialogContent className="confirmation-dialog-content">
          <Box className="confirmation">
            {getIconForAction(confirmColor)}
            <Typography variant="body1" className="confirmation-message">
              {message}
            </Typography>
          </Box>
        </DialogContent>
      </SC.ConfirmationDialog>
      <DialogActions sx={{ p: 3, gap: 2 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          disabled={isLoading}
          fullWidth
        >
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          variant={confirmColor === "error" ? "contained" : "outlined"}
          color={confirmColor === "warning" ? "info" : confirmColor}
          disabled={isLoading}
          fullWidth
          startIcon={
            isLoading ? (
              <CircularProgress className="icon-btn" size={20} />
            ) : undefined
          }
          sx={{
            ...(confirmColor === "error" && {
              backgroundColor: "error.main",
              "&:hover": {
                backgroundColor: "error.dark",
              },
            }),
            ...(confirmColor === "warning" && {
              color: "info.main",
              borderColor: "info.main",
              "&:hover": {
                backgroundColor: "info.50",
                borderColor: "info.dark",
              },
            }),
          }}
        >
          {isLoading ? "در حال پردازش..." : confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
